import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, RadioGroup } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent, WorksheetAssociatedTestSection, WorksheetEquipmentDropdown } from '../../../../Core';
import { WorksheetBalanceFieldSet } from '../../../../Core/WorksheetEquipment';
import externalTestMethods from '../../../../ExternalTestMethods';
import { GrainSize } from '../../../types';

let AsPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const grainSizeOptions: Array<{ label: string; value: GrainSize }> = [
    { label: 'Fine', value: GrainSize.Fine },
    { label: 'Medium', value: GrainSize.Medium },
    { label: 'Coarse', value: GrainSize.Coarse },
  ];

  //Grain Size may be hidden for tests with an embedded/measured MC test
  const hideGrainSize = useSelector(pipe(createWorksheetSelector!('Preparation.HideGrainSize'), valueOrDefault(false)));
  const applyCorrection = useSelector(
    pipe(createWorksheetSelector!('Preparation.ApplyCorrection'), valueOrDefault(false))
  );
  //Import will be supported (QP-7597) once we can import worksheets that a children of the work order.
  // const importedMoistureCorrelationId = useSelector(
  //   createWorksheetSelector!('Preparation.AssociatedMoistureCorrelation.ImportedTest.Id')
  // );
  return (
    <>
      <Field
        input={<RadioGroup />}
        name="Preparation.ApplyCorrection"
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
      />
      {applyCorrection && (
        <WorksheetAssociatedTestSection
          heading="Correlation with Oven-Dry Method"
          name={`Preparation.AssociatedMoistureCorrelation`}
          testType="Moisture Correlation"
          associatedTestModel={{
            //Import will be supported (QP-7597) once we can import worksheets that a children of the work order.
            // imported: {
            //   queryParams: {
            //     includeWorkOrderLevelWorksheets: true,
            //   },
            //   importedTestResults: (
            //     <ListFieldSection>
            //       <Field input={<TextOutput />} label="A (Intercept)" name="Preparation.Intercept" emph />
            //       <Field input={<TextOutput />} label="B (Slope)" name="Preparation.Slope" emph />
            //     </ListFieldSection>
            //   ),
            //   importModel: {
            //     Id: importedMoistureCorrelationId,
            //   },
            // },
            external: {
              testMethods: [externalTestMethods.moistureContentCorrelation.AS_1289_2_3_1],
              permitOtherTestMethods: true,
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    label="A (Intercept)"
                    name="Preparation.AssociatedMoistureCorrelation.ExternalTest.Results.Intercept"
                  />
                  <Field
                    input={<NumericInput />}
                    label="B (Slope)"
                    name="Preparation.AssociatedMoistureCorrelation.ExternalTest.Results.Slope"
                  />
                </ListFieldSection>
              ),
            },
          }}
          visible={applyCorrection}
        />
      )}
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name="Preparation.GrainSize"
          options={grainSizeOptions}
          visible={!hideGrainSize}
        />
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="hotplate" name="Equipment.Hotplate" />
      </ListFieldSection>
    </>
  );
};

AsPreparationSection = withInjectedProps(AsPreparationSection);

export { AsPreparationSection };
export default AsPreparationSection;
